import React from 'react'
import './styles.scss'


export const GlobalColors = () => null
